import { LOCALSTORAGE_KEYS } from "@circle-react/config/Settings";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";
import type { Query } from "react-query";

import { browserLocalStorage } from "@/react/lib/browserStorage";

// 1 day
export const QUERY_PERSIST_MAX_AGE = 1000 * 60 * 60 * 24;

// Remove legacy pundit user cache.
browserLocalStorage.removeItem(LOCALSTORAGE_KEYS.PunditUserContext);

// Only persist queries that are successful and have the persist flag set.
const shouldPersistQuery = (query: Query) =>
  query.state.status === "success" && query.meta?.persist === true;

const queryPersister = createSyncStoragePersister({
  storage: browserLocalStorage,
  key: LOCALSTORAGE_KEYS.QueryClient,
});

export const queryPersistOptions: Omit<
  PersistQueryClientOptions,
  "queryClient"
> = {
  persister: queryPersister,
  maxAge: QUERY_PERSIST_MAX_AGE,
  dehydrateOptions: {
    shouldDehydrateQuery: shouldPersistQuery,
    // It persists offline mutations by default but we don't support them yet.
    shouldDehydrateMutation: () => false,
  },
};
